import { Component } from '@angular/core';

@Component({
    selector: 'app-zentra-admin-success-dialog',
    templateUrl: './zentra-admin-success-dialog.component.html',
    styleUrls: ['./zentra-admin-success-dialog.component.scss'],
    standalone: false
})
export class ZentraAdminSuccessDialogComponent {

}
